import { toast } from "react-toastify";
import { Endpoints } from "./Endpoints";
const baseUrl = `${process.env.REACT_APP_API_URL}/api/`;
export class EmailBlacklistService {
  static getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("token"),
    };
  }
  static async list() {
    const requestOptions = {
      method: "GET",
      headers: this.getHeaders(),
    };
    try {
      const respJson = await fetch(
        baseUrl + Endpoints.EMAIL_BLACKLIST,
        requestOptions
      );
      return await respJson.json();
    } catch (error) {
      toast.error("Could not get serves.");
      return error.message;
    }
  }

  static async create(payload) {
    const requestOptions = {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(payload),
    };
    try {
      const respJson = await fetch(
        baseUrl + Endpoints.EMAIL_BLACKLIST,
        requestOptions
      );
      return await respJson.json();
    } catch (error) {
      toast.error("Could not create serve.");
      return error.message;
    }
  }

  static async delete(id) {
    const requestOptions = {
      method: "DELETE",
      headers: this.getHeaders(),
    };
    try {
      const respJson = await fetch(
        baseUrl + Endpoints.EMAIL_BLACKLIST + `/${id}`,
        requestOptions
      );
      return await respJson.json();
    } catch (error) {
      toast.error("Could not delete serve.");
      return error.message;
    }
  }
}
